// src/types/bookings/FrontDesk.ts
var FrontDeskRefusal = /* @__PURE__ */ ((FrontDeskRefusal2) => {
  FrontDeskRefusal2["CheckInTooEarly"] = "CHECK_IN_TOO_EARLY";
  FrontDeskRefusal2["NoShowTooEarly"] = "NO_SHOW_TOO_EARLY";
  FrontDeskRefusal2["BookingNotConfirmed"] = "BOOKING_NOT_CONFIRMED";
  FrontDeskRefusal2["BookingNotCheckedIn"] = "BOOKING_NOT_CHECKED_IN";
  return FrontDeskRefusal2;
})(FrontDeskRefusal || {});
var BookingListPreset = /* @__PURE__ */ ((BookingListPreset2) => {
  BookingListPreset2["Arrivals"] = "arrivals";
  BookingListPreset2["Departures"] = "departures";
  BookingListPreset2["InHouse"] = "in_house";
  BookingListPreset2["StayOver"] = "stay_over";
  return BookingListPreset2;
})(BookingListPreset || {});

export {
  FrontDeskRefusal,
  BookingListPreset
};
